import { Configuration } from '../../capability-spec/constraints/configurations/Configuration'
import { ScrapQuantitySpec } from './scrap-quantity-spec'

export class ScrapRule {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public conditions: Configuration[]

  public quantitySpec: ScrapQuantitySpec = new ScrapQuantitySpec()

  public description: string

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.conditions = []
    this.description = ''
  }
}
